import React, { useState } from 'react';
import Button from '../Button/Button';
import { useMiddleman } from '@hubins/middleman';
import __ from 'localisation';

const SyncUserButton = ({ portfolioUuid }) => {
  const middleman = useMiddleman();


  const [loading, setLoading] = useState(false);

  const syncUser = async () => {
    try {
      setLoading(true);
      await middleman.get(`/ql/crm/sync/${portfolioUuid}`);
      window.location.reload();
      // setLoading(false);
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  return (
    <Button
      className='secondary'
      loading={loading}
      disabled={loading}
      onClick={syncUser}
      icon={"loading"}
    >
      {__('sync_user')}
    </Button>
  );
};

export default SyncUserButton;